import React,{useState} from 'react'
import { login } from '../util/api';
import { authenticate } from '../util/auth';
import { Link, useNavigate } from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux"
import { updateNotificationSuccess } from '../redux/notificationRedux';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';


export default function Login() {
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const [forgotPass, setforgotPass] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, seterror] = useState("")
    const [useremail, setuseremail] = useState("")
    let notification = useSelector((state)=> state.notification.notification)
    const handleClick = (e) =>{
        e.preventDefault()
        login(dispatch,{username,password})
        .then(response => {
            if (response === undefined) {
                seterror("Wrong Credintial");
            }else{
                authenticate(response.accessToken, ()=>{
                    dispatch(updateNotificationSuccess({sms:"Login Success",status:true}))
                    navigate('/dashboard')
                });
            }
        });
    };

    const generatePassword = () =>{
        const randomPassword =
        Math.random().toString(26).slice(-6) + Math.random().toString(26).slice(-6);
  
        // setPassword(randomPassword);
        return randomPassword;
    }

    const handleForgotPass = async (e) =>{
        e.preventDefault()
        let userInfo = {
          email: useremail,
          password:generatePassword()
        }
        const res = await axios({method:'post',url:`${process.env.REACT_APP_BASE_URL}/api/auth/admin/mailto`, data:userInfo}).then((res)=>{
            console.log(res);
        })
            // console.log(res.response);
            if(res === undefined){
                setforgotPass(false)
                dispatch(updateNotificationSuccess({sms:`Please check your email for your password`,status:true}))
                 setTimeout(() => {
                  dispatch(updateNotificationSuccess({sms:"",status:null}))
                 }, 3000)
            }
        //   if (res === undefined) {
        //     seterror("Something went wrong")
        //   } else {
        //     dispatch(updateNotificationSuccess({sms:`A verfication email has been sent to your email`,status:true}))
        //     setTimeout(() => {
        //         dispatch(updateNotificationSuccess({sms:"",status:null}))
        //         setforgotPass(false)
        //     }, 3000);
        //   }  
    }

  return (
    <>
    {forgotPass? (
        <div className='forgotpasswordpopup'>
            {/* <form>
                <label>Email</label>
                <input className='form-control mt-2' type='email' required placeholder='eg. youremail@gmail.com' />
                <button className='btn theme-btn d-block m-auto mt-3'>Submit</button>
            </form> */}
            <form className="theme-form login-form" onSubmit={handleForgotPass}>
                <i style={{cursor:"pointer"}} onClick={()=>setforgotPass(false)}><FontAwesomeIcon icon={faTimes} /></i>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input type="email" className="form-control" id="email" onChange={(e)=>setuseremail(e.target.value)} required/>
                </div>
                <p style={{color:"red"}}>{error}</p>
                <button className='btn theme-btn d-block m-auto mt-3' type='submit'>
                    Submit
                </button> 
            </form>
        </div>
    ) : (
        ""
    )}
    <div className="login">
        {notification.status === true?
            <div className='notification-bar success'>
            <FontAwesomeIcon icon={faCheck} />
            <p>{notification.sms}</p>
            </div>
            : notification.status === false?
            <div className='notification-bar failed'>
            <FontAwesomeIcon icon={faTimes} />
            <p>{notification.sms}</p>
            </div>
            :
            ""
        }
        <div className="login-logo">
            <a href="/">
                <svg
                width="194"
                height="85"
                viewBox="0 0 194 85"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    d="M182.478 29.3837C180.077 27.7351 177.643 26.5234 175.17 25.7456H194L190.583 21.3833H133.222C133.222 21.3833 126.813 21.3833 126.81 21.3833H0L3.49331 25.7456H27.2676L4.94698 39.1312L4.87655 51.7842L29.0875 62.0193V66.6212C29.0875 66.6212 26.9013 66.6945 24.4954 68.1401C24.4194 68.1852 24.3433 68.2331 24.2673 68.2838C24.1433 68.3627 24.0222 68.4416 23.901 68.5262C23.8081 68.5882 23.7179 68.6502 23.6306 68.7178C23.6249 68.7206 23.6249 68.7234 23.6221 68.7234C23.4784 68.8277 23.3348 68.932 23.1939 69.0447C22.5854 69.5209 22.022 70.0592 21.543 70.6651C21.3515 70.9074 21.1712 71.161 21.0134 71.4231C21.0106 71.4259 21.0078 71.4288 21.0078 71.4316C20.8077 71.7585 20.6359 72.1023 20.495 72.4573C20.2838 72.9899 20.1429 73.5479 20.0753 74.1172C19.7372 77.0254 20.6922 79.5222 22.946 81.6075C25.118 83.6168 27.9775 84.3635 31.5215 83.8535C31.5271 83.8535 31.53 83.8507 31.5356 83.8507C31.6652 83.8309 31.7948 83.814 31.9244 83.7915C31.9666 83.7802 32.0061 83.7718 32.0483 83.7577C35.0402 82.9742 37.1672 81.4694 38.4321 79.246C39.7167 76.9916 40.3111 74.4328 40.2125 71.5725C40.2154 71.5697 40.2182 71.5697 40.221 71.5697C40.3534 71.5358 41.2352 71.7782 42.8663 72.2995C44.5369 72.835 46.4526 73.6916 48.6106 74.8808C50.7657 76.0701 52.6448 77.5833 54.2449 79.4263L54.7549 74.7709C53.8336 73.5564 52.2335 72.2009 49.9572 70.6961C47.6781 69.1941 44.4073 68.0302 40.1421 67.2073V54.1852L36.8178 52.6775V38.5676L40.1421 36.5556V25.7456H60.809L38.4884 39.1284L38.4152 51.7842L73.6779 66.6945V34.3265C75.6161 34.5688 77.6276 35.1522 79.7123 36.0709C81.797 36.9924 83.2394 38.0576 84.0395 39.2693C84.8396 40.4839 85.2396 41.597 85.2396 42.6143C85.2396 43.5837 84.9974 44.6011 84.5156 45.6691V45.7424H84.4424C84.3945 45.2577 84.248 44.773 84.0085 44.2883C83.3296 43.1244 82.3605 42.3494 81.0984 41.9634C80.6138 41.8197 80.1293 41.7436 79.6447 41.7436C78.87 41.7436 78.1178 41.938 77.391 42.3269C75.8866 43.1019 75.1372 44.3615 75.1372 46.1087C75.1372 46.9823 75.3569 47.8277 75.7908 48.6534C76.712 50.3019 78.3122 51.1276 80.5885 51.1276C81.8506 51.1276 82.9634 50.8345 83.9325 50.254C85.3382 49.4283 86.4651 48.3969 87.3131 47.1626C88.1639 45.9255 88.7048 44.8969 88.9499 44.0684C89.2879 42.7609 89.4598 41.5012 89.4598 40.2866C89.4598 38.5423 89.0964 36.9416 88.3695 35.4875C87.1103 33.064 85.2791 31.0266 82.8817 29.3808C80.4814 27.7323 78.0474 26.5205 75.5739 25.7428H92.1446L90.9078 27.9267C95.3674 28.0705 98.4579 29.1047 100.176 31.0181C101.898 32.9344 102.224 35.0789 101.16 37.4545C99.3143 37.2601 97.8156 37.2122 96.6521 37.3108C95.8266 37.4066 95.2942 37.4799 95.0519 37.5278H94.9082L91.198 45.3845C89.5528 48.6337 89.7443 51.7589 91.7812 54.7657C92.8968 56.3184 94.1307 57.4823 95.4914 58.2544C96.8465 58.9815 98.1311 59.4916 99.3425 59.7846C100.407 60.027 101.622 60.1453 102.977 60.1453C103.413 60.1453 103.85 60.1228 104.287 60.0749C105.642 59.9312 106.783 59.3478 107.704 58.3305C108.673 57.2653 109.084 56.0536 108.941 54.6953C108.797 53.3877 108.287 52.2943 107.414 51.4235C106.54 50.5499 105.425 50.1864 104.07 50.3329C102.712 50.4767 101.622 51.06 100.799 52.0773C99.9735 53.1453 99.6101 54.3317 99.7087 55.6421C99.7566 56.1747 99.9031 56.6594 100.145 57.0962H100.072C98.9086 56.8539 98.1198 56.2367 97.7085 55.242C97.2972 54.25 97.3817 53.2412 97.9621 52.2238L101.816 46.1172L103.926 42.7721C106.25 43.4992 108.056 44.5813 109.341 46.0073C110.625 47.4388 111.547 48.8704 112.104 50.2991C112.662 51.7307 113.014 52.81 113.158 53.537V63.1353L124.21 66.6268V25.7456H129.444V63.1296L140.496 66.6184V54.4529L136.07 52.5676V38.6296L140.496 35.9638V25.7456H160.43L138.11 39.1284L138.037 51.7842L173.299 66.6945V34.3265C175.238 34.5688 177.249 35.1522 179.334 36.0709C181.418 36.9924 182.861 38.0576 183.661 39.2693C184.461 40.4839 184.861 41.597 184.861 42.6143C184.861 43.5837 184.619 44.6011 184.137 45.6691V45.7424H184.064C184.016 45.2577 183.869 44.773 183.63 44.2883C182.951 43.1244 181.982 42.3494 180.72 41.9634C180.235 41.8197 179.751 41.7436 179.266 41.7436C178.491 41.7436 177.739 41.938 177.012 42.3269C175.508 43.1019 174.759 44.3615 174.759 46.1087C174.759 46.9823 174.978 47.8277 175.412 48.6534C176.333 50.3019 177.934 51.1276 180.21 51.1276C181.472 51.1276 182.585 50.8345 183.554 50.254C184.957 49.4283 186.087 48.3969 186.934 47.1626C187.785 45.9255 188.326 44.8969 188.571 44.0684C188.909 42.7609 189.081 41.5012 189.081 40.2866C189.081 38.5423 188.718 36.9416 187.991 35.4875C186.706 33.0668 184.878 31.0294 182.478 29.3837ZM26.9774 76.2532C26.3463 76.1828 25.8252 75.8897 25.4138 75.3796C25.0025 74.8696 24.8673 74.2045 25.0138 73.3817C25.304 72.5081 25.8505 71.8909 26.6506 71.5274C27.4507 71.1639 28.262 71.0286 29.0875 71.1272C29.0875 71.7556 29.11 72.2911 29.1579 72.7279C29.2058 73.3084 29.2058 73.8297 29.1579 74.2919C29.11 74.7512 28.9156 75.1993 28.5776 75.6361C28.1381 76.1208 27.6084 76.3265 26.9774 76.2532ZM113.141 43.054C111.978 41.8901 110.741 40.9461 109.434 40.219C110.403 38.2323 110.634 35.8539 110.124 33.0922C109.614 30.3277 107.132 27.8816 102.672 25.7456H113.141V43.054Z"
                    fill="#14162A"
                />
                <path
                    d="M173.606 13.8535C175.474 11.6469 177.325 8.55556 179.167 4.58213L178.224 0C175.46 3.49155 172.758 6.2194 170.116 8.18076C167.473 10.1449 164.166 11.5878 160.191 12.5093L167.969 18.8357C169.862 17.7226 171.741 16.0628 173.606 13.8535Z"
                    fill="#14162A"
                />
                <path
                    d="M142.902 45.2041H160.315L170.319 56.3748H162.926C156.551 56.3748 150.477 53.661 146.223 48.9098L142.902 45.2041Z"
                    fill="url(#paint0_linear_711_410)"
                />
                <path
                    d="M142.902 45.2041H160.315L170.319 34.0334H162.926C156.551 34.0334 150.477 36.7472 146.223 41.4984L142.902 45.2041Z"
                    fill="url(#paint1_linear_711_410)"
                />
                <path
                    d="M13.4126 45.2041H24.2531L30.4819 52.159H24.9546C21.574 52.159 18.3511 50.719 16.0946 48.1997L13.4126 45.2041Z"
                    fill="url(#paint2_linear_711_410)"
                />
                <path
                    d="M13.4126 45.2041H24.2531L30.4819 38.2492H24.9546C21.574 38.2492 18.3511 39.6892 16.0946 42.2085L13.4126 45.2041Z"
                    fill="url(#paint3_linear_711_410)"
                />
                <path
                    d="M45.4385 45.2041H59.7273L67.9365 54.3712H61.8683C56.6368 54.3712 51.6504 52.1421 48.1599 48.2448L45.4385 45.2041Z"
                    fill="url(#paint4_linear_711_410)"
                />
                <path
                    d="M45.4385 45.2041H59.7273L67.9365 36.037H61.8683C56.6368 36.037 51.6504 38.2661 48.1599 42.1634L45.4385 45.2041Z"
                    fill="url(#paint5_linear_711_410)"
                />
                <defs>
                    <linearGradient
                    id="paint0_linear_711_410"
                    x1="164.979"
                    y1="58.3207"
                    x2="147.535"
                    y2="41.6211"
                    gradientUnits="userSpaceOnUse"
                    >
                    <stop stopColor="#F36F4E" />
                    <stop offset="1" stopColor="#EE2D77" />
                    </linearGradient>
                    <linearGradient
                    id="paint1_linear_711_410"
                    x1="152.933"
                    y1="34.2746"
                    x2="161.635"
                    y2="46.9136"
                    gradientUnits="userSpaceOnUse"
                    >
                    <stop stopColor="#F36F4E" />
                    <stop offset="1" stopColor="#EE2D77" />
                    </linearGradient>
                    <linearGradient
                    id="paint2_linear_711_410"
                    x1="28.3815"
                    y1="53.4801"
                    x2="17.5466"
                    y2="44.6589"
                    gradientUnits="userSpaceOnUse"
                    >
                    <stop stopColor="#29BBED" />
                    <stop offset="1" stopColor="#107EC2" />
                    </linearGradient>
                    <linearGradient
                    id="paint3_linear_711_410"
                    x1="17.2433"
                    y1="37.1904"
                    x2="26.2318"
                    y2="45.848"
                    gradientUnits="userSpaceOnUse"
                    >
                    <stop stopColor="#29BBED" />
                    <stop offset="1" stopColor="#107EC2" />
                    </linearGradient>
                    <linearGradient
                    id="paint4_linear_711_410"
                    x1="58.2281"
                    y1="59.4208"
                    x2="55.9454"
                    y2="45.1581"
                    gradientUnits="userSpaceOnUse"
                    >
                    <stop stopColor="#FFD845" />
                    <stop offset="0.0525" stopColor="#FFD446" />
                    <stop offset="0.6947" stopColor="#FAA84F" />
                    <stop offset="1" stopColor="#F79751" />
                    </linearGradient>
                    <linearGradient
                    id="paint5_linear_711_410"
                    x1="55.8462"
                    y1="37.2452"
                    x2="58.8173"
                    y2="45.7391"
                    gradientUnits="userSpaceOnUse"
                    >
                    <stop stopColor="#FFD845" />
                    <stop offset="0.0525" stopColor="#FFD446" />
                    <stop offset="0.6947" stopColor="#FAA84F" />
                    <stop offset="1" stopColor="#F79751" />
                    </linearGradient>
                </defs>
                </svg>
            </a>
        </div>
      <p>Admin panel</p>
      <form className="theme-form login-form" onSubmit={handleClick}>
        <div className="form-group">
          <label htmlFor="username">Username</label>
          <input type="text" className="form-control" id="username" onChange={e=>setUsername(e.target.value)} required/>
        </div>
        <div className="form-group">
          <label htmlFor="pass">Password</label>
          <input type="password" className="form-control" id="pass" onChange={e=>setPassword(e.target.value)} required/>
        </div>
        <a style={{display:"block",textAlign:"right",fontWeight:"600",marginBottom:"10px",cursor:"pointer"}} onClick={()=>setforgotPass(true)}>Forgot Password!</a>
        <p style={{color:"red"}}>{error}</p>
        <button className="btn theme-btn" type="submit">Login</button>
      </form>
    </div>
    </>
  )
}
